import { render, staticRenderFns } from "./ISPDashboard.vue?vue&type=template&id=b290b384&"
import script from "./ISPDashboard.vue?vue&type=script&lang=js&"
export * from "./ISPDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports